/*
 * Copyright (C) 2023 - present Marek Kuzora - All Rights Reserved.
 */


export default
{
  Planet: 0,
  Platform: 1,
};
